<template>
  <div
    v-if="hasAttributes"
    class="product-attributes-fi"
  >
    <div class="product-attributes-fi__label">
      {{ $dict.get('online-Shop.Product.Attributes-Label') }}
    </div>
    <div class="product-attributes-fi__attributes">
      <icon-attribute-item-fi
        v-if="attributeName(attributes, 'ANZAHL_BAUTEILE')"
        icon="puzzle"
        :label="attributeName(attributes, 'ANZAHL_BAUTEILE')"
        :value="attributeValue(attributes, 'ANZAHL_BAUTEILE')"
      />
      <icon-attribute-item-fi
        v-if="attributeName(attributes, 'ANZAHL_MODELLE')"
        icon="module"
        :label="attributeName(attributes, 'ANZAHL_MODELLE')"
        :value="attributeValue(attributes, 'ANZAHL_MODELLE')"
      />
      <icon-attribute-item-fi
        v-if="attributeName(attributes, 'ALTER_AB')"
        icon="age"
        :label="attributeName(attributes, 'ALTER_AB')"
        :value="attributeValue(attributes, 'ALTER_AB')"
      />
    </div>
  </div>
</template>

<script>
import { IconAttributeItemFi } from 'atoms';

import catalogAttributesMixin from '@/mixins/catalogAttributesMixin.vue';

export default {
  name: 'ProductAttributesFi',
  components: {
    IconAttributeItemFi,
  },
  mixins: [catalogAttributesMixin],
  props: {
    attributes: {
      type: Array,
      default: null,
    },
  },
  computed: {
    hasAttributes() {
      return Boolean(
        this.attributeName(this.attributes, 'ANZAHL_BAUTEILE') ||
          this.attributeName(this.attributes, 'ANZAHL_MODELLE') ||
          this.attributeName(this.attributes, 'ALTER_AB'),
      );
    },
  },
};
</script>

<style scoped src="./product-attributes-fi" />
